import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';

import type {
  BulkUpdateResponse,
  PaginatedNotificationsResponse,
  UnreadCountResponse,
} from '../types';

const BASE_URL = `${OPAL_URL}/notification-service/api/v1/notifications`;

export type FetchOffsetNotificationsParams = {
  limit: number;
  offset: number;
  is_read?: boolean;
  agent_id?: string;
};

export type FetchCursorNotificationsParams = {
  limit: number;
  cursor?: string | null;
  is_read?: boolean;
  agent_id?: string;
};

export async function fetchOffsetNotifications(params: FetchOffsetNotificationsParams) {
  const searchParams = new URLSearchParams({
    limit: params.limit.toString(),
    offset: params.offset.toString(),
  });
  if (params.is_read !== undefined) searchParams.set('is_read', params.is_read.toString());
  if (params.agent_id) searchParams.set('agent_id', params.agent_id);

  const res = await http.get<PaginatedNotificationsResponse>(`${BASE_URL}?${searchParams}`);
  return res.data;
}

export async function fetchCursorNotifications(params: FetchCursorNotificationsParams) {
  const searchParams = new URLSearchParams({
    limit: params.limit.toString(),
  });
  if (params.cursor) searchParams.set('cursor', params.cursor);
  if (params.is_read !== undefined) searchParams.set('is_read', params.is_read.toString());
  if (params.agent_id) searchParams.set('agent_id', params.agent_id);

  const res = await http.get<PaginatedNotificationsResponse>(`${BASE_URL}?${searchParams}`);
  return res.data;
}

export async function fetchUnreadCount() {
  const res = await http.get<UnreadCountResponse>(`${BASE_URL}/unread-count`);
  return res.data;
}

export async function markAsRead(id: string) {
  await http.patch(`${BASE_URL}/${id}/read`);
}

export async function markAsUnread(id: string) {
  await http.patch(`${BASE_URL}/${id}/unread`);
}

export async function bulkMarkAsRead(ids?: string[]) {
  const res = await http.patch<BulkUpdateResponse>(
    `${BASE_URL}/bulk-read`,
    ids ? { ids } : undefined
  );
  return res.data;
}

export async function bulkMarkAsUnread(ids?: string[]) {
  const res = await http.patch<BulkUpdateResponse>(
    `${BASE_URL}/bulk-unread`,
    ids ? { ids } : undefined
  );
  return res.data;
}

export async function deleteNotification(id: string) {
  await http.delete(`${BASE_URL}/${id}`);
}

export async function bulkDelete(ids?: string[]) {
  const res = await http.post<BulkUpdateResponse>(
    `${BASE_URL}/bulk-delete`,
    ids ? { ids } : undefined
  );
  return res.data;
}
